module.exports = __webpack_public_path__ + "static/signet1-9e2e5d7f63983db0f0f6f2019269bb03.svg";